import { CepId, TripType } from '@flysas-tech/book-value-stream-models';
import { Static, Type, String, Number, Optional, Union, Literal } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';

export type RevenueFlightOffersRequestQuery = Static<typeof RevenueFlightOffersRequestQuery>;
export const RevenueFlightOffersRequestQuery = Type.Object({
  origin: String({
    examples: ['ARN'],
    description: 'Origin airport code',
    pattern: '[A-Z]{3}',
  }),
  destination: String({
    examples: ['CPH'],
    description: 'Destination airport code',
    pattern: '[A-Z]{3}',
  }),
  tripType: UnionEnum([TripType.ONE_WAY, TripType.ROUND_TRIP, TripType.OPEN_JAW], {
    description: 'Specifies if it is a round trip or a one way trip',
    examples: [TripType.ONE_WAY, TripType.ROUND_TRIP],
  }),
  outboundDate: String({
    examples: ['2024-08-20'],
    description: 'Date of departure',
  }),
  inboundDate: Optional(
    String({
      examples: ['2024-08-30'],
      description: 'Date of return trip (required for round-trip)',
    })
  ),
  adults: Number({
    maximum: 9,
    description: 'Number of adult travelers',
    examples: [2],
  }),
  youths: Number({
    maximum: 9,
    description: 'Number of youth travelers',
    examples: [2],
  }),
  children: Number({
    description: 'Number of children',
    examples: [1],
  }),
  infants: Number({
    description: 'Number of infants (must be equal or less to the number of adult travelers)',
    examples: [1],
  }),
  selectedCouponCodes: Optional(String()),
  selectedOutboundId: Optional(String()),
  offerId: Optional(String()),
  cepId: Optional(Union(Object.values(CepId).map(id => Literal(id)))),
});
